import { useQueryClient } from "@tanstack/react-query";

import {
  getGetVisitScheduleVisitsGetQueryKey,
  useGetVisitScheduleVisitsGet,
} from "@/api-v3";

export const useVisitSchedule = (
  options: { enabled?: boolean } = { enabled: true }
) => {
  const queryClient = useQueryClient();

  const { data, isLoading, error, refetch, isFetching } =
    useGetVisitScheduleVisitsGet(undefined, {
      query: {
        refetchOnMount: "always",
        refetchOnWindowFocus: "always",
        select: (response) => response.data.visits,
        enabled: options.enabled,
      },
    });

  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: getGetVisitScheduleVisitsGetQueryKey(),
    });
  };

  return {
    visits: data ?? [],
    visitsLoading: isLoading,
    visitsError: error,
    refetchVisits: refetch,
    visitsFetching: isFetching,
    invalidateVisitSchedule: invalidate,
  };
};
